<template>
  <div>
    <div class="chart-holder">
      <column-chart
        :library="chartOptions"
        :data="data"
        :colors="['#4cf2f0']"
        :legend="false"
        height="100%"
        width="100%"
      />
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';

import AdminClient from '@/api/AdminClient';

Vue.use(Chartkick.use(Chart));
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];


export default {
    name: 'SessionsByMonth',
    props: {
        report: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            adminClient: new AdminClient(this.$http),
            data: null,
            chartOptions: {
                layout: {
                    padding: {
                    left: 10,
                    right: 5,
                    top: 5,
                    bottom: 2,
                },
            },
            scales: {
                xAxes: [{
                display: true,
                ticks: {
                    fontSize: 10,
                    fontColor: '#c8d2dc',
                    },
                }],
                yAxes: [{
                    display: false,
                    ticks: {
                        fontSize: 14,
                        fontColor: '#c8d2dc',
                    },
                }],
            },
            elements: {
                point: {
                    radius: 4,
                },
            },
            defaultFontFamily: "'Playfair Display', Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            defaultFontSize: 30,
            borderWidth: 0,
        },
        }
    },
    mounted() {
        const monthReports = this.report.month_reports || [];

        if (monthReports.length) {
          const data = monthReports.reduce((a, e, i) => {
            if (i === 0) {
              return a;
            }

            const monthName = monthNames[e.month - 1];
            const key = monthName.toUpperCase().substring(0, 3);

            a[key] = e.number_of_appointments || 0;
            return a;
          }, {});

          this.data = [{
            name: 'Appointments',
            data,
          }];
        }
  },
}
</script>

<style lang="scss" scoped>

.chart-holder {
    position: relative;
    left: -15px;
    width: calc(100% + 15px);
    height: 200px;
  }

</style>
